<template>
  <machinery-form
    :hasWritePerm="hasWritePerm"
    :visible="newMachineryDialog"
    :dialogTitle="'hfManagement.machineryPerformance.addMachinaryDialogTitle'"
    :initFormValid="false"
    :machinery="newMachinery"
    :officeId="officeId"
    @close="closeNewMachineryFormDialog"
    @savemachinery="createMachinery"
  />
</template>

<script>
import HFMachineryForm from "./HFMachineryForm";

export default {
  components: {
    MachineryForm: HFMachineryForm
  },
  props: {
    hasWritePerm: {
      type: Boolean,
      required: true
    },
    officeId: {
      type: String,
      required: true
    },
    newMachineryDialog: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    newMachineryDialog: {
      handler: function () {
        if (this.newMachineryDialog) {
          this.$store.commit("machinery/RESET_MACHINERY_FORM");
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    closeNewMachineryFormDialog() {
      this.$emit("closenewmachineryformdialog");
    },
    createMachinery() {
      this.$store
        .dispatch("machinery/createMachinery", this.officeId)
        .then(machineryId => {
          return this.allAddServicePromises(machineryId);
        })
        .then(() => {
          this.closeNewMachineryFormDialog();
        })
        .then(() => {
          this.$store.dispatch("machinery/fetchOfficeEquipment", this.officeId);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    allAddServicePromises(machineryId) {
      return Promise.all(
        this.newMachineryForm.serviceList.map(
          this.singleAddServicePromise(machineryId)
        )
      );
    },
    singleAddServicePromise(machineryId) {
      return service => {
        return new Promise((resolve, reject) => {
          return this.$store
            .dispatch("machinery/addMachineryService", {
              machineryService: {
                machineryId: machineryId,
                serviceId: service.serviceId
              }
            })
            .then(() => {
              resolve();
            })
            .catch(error => {
              reject(error);
            });
        });
      };
    }
  },
  computed: {
    newMachinery() {
      return this.$store.getters["machinery/machineryForm"];
    },
    newMachineryForm() {
      return this.$store.getters["machinery/machineryForm"];
    }
  }
};
</script>
